import React from 'react'
import { twMerge } from 'tailwind-merge'

const Button = ({
  text,
  onClick,
  filled,
  className,
  type = "button",
  disabled = false,
}) => {
  const baseClassName = disabled
    ? 'cursor-not-allowed opacity-60 shadow-none'
    : 'hover:shadow-lg shadow-md duration-200';

  return (

    <div>
      {
        filled ?
        <button disabled={disabled} onClick={onClick} type={type} className={twMerge('outline-none rounded-3xl px-6 py-2 text-accentYellow border-2 border-accentYellow font-semibold', baseClassName, className)}>{text}</button>:
         <button disabled={disabled} onClick={onClick} type={type} className={twMerge('outline-none rounded-3xl px-6 py-2 text-white bg-accentYellow font-semibold', baseClassName, className)}>{text}</button> 
          
      }
    </div>
  )
}

export default Button
